import {
  useRecentlyUsedStore,
  useSlidesLibraryStore,
} from "@modules/slides-library/shared";
import { IconClock } from "@tabler/icons-react";
import { useSearchSavedSlides } from "../hooks";
import { SavedSlidesGrid } from "./saved-slides-grid";
import { SearchResults } from "./search-results";
import { SingleSlide } from "./single-slide";

const RecentlyUsedGrid = () => {
  const type = useSlidesLibraryStore((s) => s.type);
  const category = type === "team-slides" ? "team-slides" : "user-slides";
  const slides = useRecentlyUsedStore((s) => s.savedSlides[category]);

  if (slides.length === 0) return null;

  return (
    <div>
      <div className="tw-flex tw-h-[52px] tw-flex-row tw-items-start tw-justify-between tw-py-4">
        <div className="tw-flex tw-items-center tw-gap-1.5">
          <IconClock className="tw-size-3.5 tw-text-blue" stroke={1.5} />
          <span className="tw-font-sans tw-text-[14px] tw-leading-5 tw-font-medium tw-text-blue">
            Recently used
          </span>
        </div>
      </div>
      <div className="tw-grid tw-grid-cols-3 tw-gap-6">
        {slides.map((slide) => (
          <SingleSlide key={slide._id} slide={slide} />
        ))}
      </div>
    </div>
  );
};

export const SavedSlidesView = () => {
  const { data, search } = useSearchSavedSlides();
  const folderId = useSlidesLibraryStore((s) => s.folderId);
  const isAtRoot = folderId === "user-slides" || folderId === "team-slides";

  if (search) return <SearchResults data={data ?? []} />;
  return (
    <div className="tw-space-y-6 tw-px-6 tw-py-4">
      {isAtRoot && <RecentlyUsedGrid />}
      <SavedSlidesGrid />
    </div>
  );
};
